import { render, staticRenderFns } from "./UploadCalls.vue?vue&type=template&id=4c3fee77&scoped=true&"
import script from "./UploadCalls.vue?vue&type=script&lang=js&"
export * from "./UploadCalls.vue?vue&type=script&lang=js&"
import style0 from "./UploadCalls.vue?vue&type=style&index=0&id=4c3fee77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3fee77",
  null
  
)

export default component.exports